import React from 'react';
import AttendeesNavbar from './attendees-navbar/attendees-navbar';
import AttendeesTable from './attendees-table/attendees-table';

const AttendeesListContainer = (): JSX.Element => (
  <section className='attendees-list-container'>
    <AttendeesNavbar/>
    <AttendeesTable/>
  </section>
);

export default AttendeesListContainer;